module.exports = __webpack_public_path__ + "img/EPS.ff26e10d.png";